import type { CallStatusResourceResponseListResponseApi } from '@ingenico/api-sdk-device-management-private';
import type { BusinessServiceRequest } from '@ingenico/react-section-utils';
import { useCurrentUser } from '@ingenico/react-section-utils';
import type { DeviceChangesCallLog } from '@ingenico/react-ui';
import { useUserDateTimeFormat } from '@ingenico/react-utils/hooks';
import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import { camelCase, toArray, toString } from 'lodash-es';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useGenerateProvisioningTargetDeviceCallLogs(
  { data: responseData }: BusinessServiceRequest<CallStatusResourceResponseListResponseApi>,
  virtualDeviceId = '',
): DeviceChangesCallLog[] {
  const currentUser = useCurrentUser();
  const { getUserDateTimeFormat } = useUserDateTimeFormat(currentUser?.dateTimeFormat);
  const { t } = useTranslation([ALL_LNGS_NAMESPACES.CALL_LOGS]);

  return useMemo(
    () =>
      toArray(
        responseData?.data?.map(({ callDateTime, status, statusSummary, callId }) => ({
          reason: t(`values.callReason.${camelCase(toString(statusSummary))}`, {
            ns: ALL_LNGS_NAMESPACES.CALL_LOGS,
          }),
          callDate: getUserDateTimeFormat({ instant: callDateTime?.toString() }),
          status,
          callId,
          virtualDeviceId,
        })),
      ),
    [responseData?.data, getUserDateTimeFormat, t, virtualDeviceId],
  );
}
